module.exports = __webpack_public_path__ + "img/8.f3df03bf.png";